module.exports = __webpack_public_path__ + "images/market/introduction/3_92221956d25a77ac1f03678f9a1211d7.png";